export default __webpack_public_path__ + "static/media/SaiTejaMalladi.fe6e635e.pdf";